module.exports = __webpack_public_path__ + "static_portal/img/upload_video_button.1036a9d6.jpg";